import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bloco-endereco-destinatario-interno',
  templateUrl: './bloco-endereco-destinatario-interno.component.html',
  styleUrls: ['./bloco-endereco-destinatario-interno.component.scss']
})
export class BlocoEnderecoDestinatarioInternoComponent implements OnInit {
  @Input('Tipo') tipo: string;
  @Input('RazaoSocial') razaoSocial: string;
  @Input('Endereco') endereco: string;
  @Input('Bairro') bairro: string;
  @Input('Cidade') cidade: string;
  @Input('UF') uf: string;
  @Input('CEP') cep: string;
  @Input('CGC') cgc: string;
  @Input('Telefone1') telefone: string;
  @Input('Telefone2') telefone2: string;
  @Input('Telefone3') telefone3: string;
  constructor() { }

  ngOnInit() {
  }

}
